import { render } from "./ChangePassword.vue?vue&type=template&id=73cdf3ac"
import script from "./ChangePassword.vue?vue&type=script&lang=js"
export * from "./ChangePassword.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Katongole R\\Desktop\\Projects\\Portal\\mfuko-portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__